import React, { useEffect, useRef } from "react";

export function usePrevious(value: any) {
    const ref = useRef(0);
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}
